import { useState } from 'react';
import styled from 'styled-components';

import CopyIcon from 'assets/icons/copy2.svg';
import SuccessIcon from 'assets/icons/notifications2/success.svg';
import { resetButton } from 'styles/common';

import { Copy } from './Copy';

const Button = styled.button`
  ${resetButton}
  display: flex;

  svg {
    width: 18px;

    path {
      fill: rgba(255, 255, 255, 0.4);
    }
  }

  &:hover {
    svg path {
      fill: rgba(255, 255, 255, 0.6);
    }
  }
`;

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  copyText: string;
  successText?: string;
};

export const CopyButton = (props: Props) => {
  const { copyText, successText = 'Address copied', ...buttonProps } = props;
  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <Copy
      copyText={copyText}
      successText={successText}
      onTooltipOpen={() => setIsSuccess(true)}
      onTooltipClose={() => setIsSuccess(false)}
    >
      <Button {...buttonProps}>{isSuccess ? <SuccessIcon /> : <CopyIcon />}</Button>
    </Copy>
  );
};
